// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 查询分页
 * @param params
 * @returns {*}
 */
export function page(params) {
  return axios.get('/system/head/page', {params: params}).then(res => res.data);
}
/**
 * 删除头像
 * @returns {*}
 */
export function delHead(headId) {
  return axios.post('/system/head/del/' + headId).then(res => res.data);
}
/**
 * 增加头像
 * @returns {*}
 */
export function addHead(data) {
  return axios.post('/system/head/add', data).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/like.js